import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Banner, BannerResponse } from '../models/banner.model';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private apiUrl = environment.baseApi;

  constructor(private http: HttpClient) {}

  getBanners(): Observable<BannerResponse> {
    return this.http.get<BannerResponse>(`${this.apiUrl}banners/`);
  }
}
